import { Icon, IconButton, Text, tokens } from '@/design';

interface ThreeDCompassProps {
  headingDeg: number;
  tiltDeg: number;
  onResetNorth(): void;
}

export function ThreeDCompass({ headingDeg, tiltDeg, onResetNorth }: ThreeDCompassProps) {
  const normalizedHeading = ((headingDeg % 360) + 360) % 360;
  return (
    <div
      role="group"
      aria-label={`Compass bearing ${normalizedHeading.toFixed(0)} degrees, tilt ${tiltDeg.toFixed(
        0,
      )} degrees`}
      style={{
        position: 'absolute',
        bottom: tokens.space[2],
        right: tokens.space[2],
        zIndex: tokens.zIndex.panel,
        display: 'grid',
        justifyItems: 'center',
        gap: tokens.space[1],
      }}
    >
      <IconButton aria-label="Reset camera to north (C)" onClick={onResetNorth}>
        <Icon name="explore" size={20} decorative />
      </IconButton>
      <Text variant="caption" as="span">
        {normalizedHeading.toFixed(0)} deg / {tiltDeg.toFixed(0)} deg
      </Text>
    </div>
  );
}
